export const FOOD_OVERLAY_HINT_MIN_REVEALED_TILES = 5;
export const FOOD_OVERLAY_HINT_MIN_TURN = 3;
export const LAND_RECOVERY_HINT_TURN = 2;

export interface FoodOverlayHintInput {
  revealedTileCount: number;
  turn: number;
}

export interface LandRecoveryHintInput {
  turn: number;
  reactiveDepletionNotified: boolean;
}

export function shouldPushFoodOverlayHint(input: FoodOverlayHintInput): boolean {
  return (
    input.revealedTileCount >= FOOD_OVERLAY_HINT_MIN_REVEALED_TILES ||
    input.turn >= FOOD_OVERLAY_HINT_MIN_TURN
  );
}

export function shouldPushLandRecoveryHint(input: LandRecoveryHintInput): boolean {
  return input.turn >= LAND_RECOVERY_HINT_TURN && !input.reactiveDepletionNotified;
}

export function populationChangeKind(
  before: number,
  after: number,
): "growth" | "famine" | null {
  if (after > before) {
    return "growth";
  }

  if (after < before) {
    return "famine";
  }

  return null;
}
